const purchaseFuelsPathname = {
  PURCHASE: '/app/purchase',
}

const purchasesPathname = {
  PURCHASES: 'needs',
}

const purchaseFuelPathname = {
  // TODO: Remove following lines
  SUMMARY: 'summary',
  PURCHASES: 'needs',
  SUPPLIERS_PROPOSAL: 'supplier-proposal',
  SHOPPING_CART: 'shoppingCart',
  HISTORIC: 'historic',
  SUPPLIERS: 'suppliers',
  NOTIFICATIONS: 'notifications',
  // TODO-END
  SUMMARY_PATH: `${purchaseFuelsPathname.PURCHASE}/summary`,
  PURCHASES_PATH: `${purchaseFuelsPathname.PURCHASE}/needs`,
  SUPPLIERS_PROPOSAL_PATH: `${purchaseFuelsPathname.PURCHASE}/supplier-proposal`,
  SHOPPING_CART_PATH: `${purchaseFuelsPathname.PURCHASE}/shoppingCart`,
  HISTORIC_PATH: `${purchaseFuelsPathname.PURCHASE}/historic`,
  SUPPLIERS_PATH: `${purchaseFuelsPathname.PURCHASE}/suppliers`,
  NOTIFICATIONS_PATH: `${purchaseFuelsPathname.PURCHASE}/notifications`,
}

export { purchaseFuelsPathname, purchasesPathname, purchaseFuelPathname }
